import { Section } from "../tools/section";
import Swiper from 'swiper';
import { Scrollbar } from "swiper/modules";
import AOS from 'aos';

// Selectors
const SELECTOR_SECTION = '[data-about-product]';
const SELECTOR_SWIPER_CONTAINER = '[data-swiper-container]';
const SELECTOR_SWIPER_SCROLLBAR = '[data-swiper-scrollbar]';
const SELECTOR_CAROUSEL_ITEMS = '[data-carousel-slide-item]';

export class AboutProduct extends Section {
  private swiper: Swiper | null = null;
  private swiperContainer: HTMLElement | null = null;
  private scrollbarEl: HTMLElement | null = null;

  queryChildren(container: HTMLElement) {
    this.swiperContainer = container.querySelector(SELECTOR_SWIPER_CONTAINER);
    this.scrollbarEl = container.querySelector(SELECTOR_SWIPER_SCROLLBAR);
  }

  attachEvents() {
    if (this.swiperContainer && this.scrollbarEl) {
      this.initSwiper();
    }
    
    // Initialize AOS animations
    AOS.init({ duration: 800, easing: 'ease-out', once: true });
    
    // Apply stagger effect to carousel items
    if (this.swiperContainer) {
      this.applyAOSStagger(this.swiperContainer);
    }
  }

  private initSwiper() {
    if (!this.swiperContainer || !this.scrollbarEl) return;

    this.swiper = new Swiper(this.swiperContainer, {
      modules: [Scrollbar],
      slidesPerView: 'auto',
      touchMoveStopPropagation: true,
      spaceBetween: 16,
      centeredSlides: false,
      freeMode: false,
      scrollbar: {
        el: this.scrollbarEl,
        draggable: true,
        dragSize: 'auto',
        snapOnRelease: true,
      },
      breakpoints: {
        480: {
          spaceBetween: 20,
        },
        750: {
          spaceBetween: 24,
        }
      }
    });
  }

  private applyAOSStagger(container: HTMLElement) {
    const slides = container.querySelectorAll<HTMLElement>(SELECTOR_CAROUSEL_ITEMS);
    slides.forEach((el, idx) => {
      const delay = idx * 160; // ms
      // Ensure required attributes exist
      el.dataset.aos = el.dataset.aos || 'fade-up';
      el.dataset.aosOnce = 'true';
      el.setAttribute('data-aos-delay', String(delay));
      // Force the delay even if AOS doesn't re-read attributes
      el.style.transitionDelay = `${delay}ms`;
      el.style.animationDelay = `${delay}ms`;
    });
  }

  detatchEvents() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

Section.register(SELECTOR_SECTION, AboutProduct);
